import React from 'react';
import Header from './../components/Header';
import Footer from './../components/Footer';
import { useLocation } from 'react-router-dom';

// Único método disponible: contra entrega. La integración con Stripe apuntaba
// al backend MERN legado, que ya no se despliega, y se eliminó.
const Payment = () => {

    const { state: {price,items,promisedDate,pendientesProveedor}} = useLocation()
    const fechaPromesa = promisedDate
        ? new Date(promisedDate + 'T12:00:00').toLocaleDateString('es-GT', { weekday: 'long', day: 'numeric', month: 'long' })
        : null


    return (
        <div>
           <Header/>
    <section className='bg-[#eeeeee]'>
        <div className='w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-16 mt-4 '>
            <div className='flex flex-wrap md:flex-col-reverse'>
                <div className='w-7/12 md:w-full'>
                    <div className='pr-2 md:pr-0'>
                        <div className='flex flex-wrap'>
        <div className='w-[20%] border-r py-8 px-12 bg-white' >
            <div className='flex flex-col gap-[3px] justify-center items-center'>
            <img src="/images/payment/cod.jpg" alt="Pago contra entrega" />
            </div>
            <span className='text-slate-600'>Contra entrega</span>
        </div>
        </div>

        <div className='w-full px-4 py-8 bg-white shadow-sm flex flex-col gap-2'>
            <p className='text-slate-600'>Tu pedido se paga en efectivo al momento de la entrega.</p>
            {fechaPromesa && (
                <p className='text-slate-800 font-semibold' data-testid='fecha-promesa'>Entrega estimada: {fechaPromesa}.</p>
            )}
            {pendientesProveedor?.length > 0 && (
                <p className='text-amber-700 text-sm'>Bajo pedido (se piden al proveedor): {pendientesProveedor.join(', ')}.</p>
            )}
        </div>

                </div> 
            </div> 

        <div className='w-5/12 md:w-full'>
            <div className='pl-2 md:pl-0 md:mb-0'>
                <div className='bg-white shadow p-5 text-slate-600 flex flex-col gap-3'>
        <h2 className='font-bold text-lg'>Order Summary </h2>
        <div className='flex justify-between items-center'>
            <span>{items} Items and Shipping Fee Included </span>
            <span>${price} </span>
        </div>
        <div className='flex justify-between items-center font-semibold'>
            <span>Total Amount </span>
            <span className='text-lg text-green-600'>${price}</span>
        </div>



                </div>
            </div>
        </div>

        </div> 
        </div>

    </section>


           <Footer/>
        </div>
    );
};

export default Payment;